<template>
  <div class="px-2 px-md-4">
    <BoxExternalServices />
  </div>
</template>

<script lang="ts" setup>
import { useAuthorizationContext } from '@/composables/deepadmin/use-authorization-context.ts'
import usePageAccess from '@/composables/deepadmin/use-page-access.ts'
import BoxExternalServices from '@/components/deepbox/box/BoxExternalServices.vue'

definePage({
  meta: {
    breadcrumbLabelKey: 'navigation.deepbox.box.deep_o',
  },
})

const { permissions } = useAuthorizationContext()

usePageAccess(computed(() => !permissions.canViewBoxes))
</script>
